const DEFAULT_REDIRECT = '/';

export function safeRedirectPath(value, fallback = DEFAULT_REDIRECT) {
  if (!value || typeof value !== 'string') return fallback;
  if (!value.startsWith('/') || value.startsWith('//')) return fallback;
  if (value.startsWith('/login') || value.startsWith('/register') || value.startsWith('/verify-email-otp')) {
    return fallback;
  }
  return value;
}

export function redirectParam(path) {
  const safe = safeRedirectPath(path);
  return `redirect=${encodeURIComponent(safe)}`;
}

export function pathWithRedirect(path, redirectTo) {
  const safe = safeRedirectPath(redirectTo);
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${redirectParam(safe)}`;
}
